/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// import { AppEnvConfig } from '../../../app.config';
// import { UserService } from '../../../../user.service';
// import { SSDWidgetServiceConstants } from '../../../ssd-widgets/_enum/service-constants';
import { environment } from '../../../../../../../../environments/environment';
import {
    CoolantHealthIqEvaContext,
    CoolantHealthIqEvaPayload,
    EvaContextPoint,
    EvaCoolantChatHistory,
    EvaCoolantConversation,
    EvaDciChatHistory,
    EvaDciConversation,
    EvaDciQueryParams,
    EvaDciRequestPayload,
    EvaDciResponse,
    EvaFeedbackContext,
    EvaFeedbackQueryParams,
    EvaFeedbackRecord,
    EvaFeedbackSaveRequest,
    EvaRequestPayload,
    EvaResponse,
    EvaV2ContextPointId,
    EvaV2RequestPayload,
    EvaV2Response
} from '../models/eva-request.model';
import { EvaState } from '../models/eva-state.model';
import { AIAgentServiceConfig } from './ai-agent.service.config';
import { BotFlowEvent } from '../models/ai-agent-flow.model';
// import { AppEnvConfig } from '../../../app.env.config';

export const EVA_FEEDBACK_IDENTIFIER_TYPES = {
    eva: 1,
    priorityCards: 2,
    insightsAndOpportunities: 4,
    map: 5
} as const;

export const EVA_FEEDBACK_IDENTIFIER_SUBTYPES = {
    eva: 1,
    priorityCardsSummary: 4,
    priorityCardsRecommendations: 5,
    insightsSummary: 7,
    insightsRecommendations: 8,
    mapSiteSummary: 9,
    mapRecommendations: 10
} as const;

@Injectable({
    providedIn: 'root'
})
export class AIAgentService {
    private readonly defaultFeedbackSourceApplicationTypeId = 10;
    private readonly defaultFeedbackSourceIdentifierTypeId = 1;
    private readonly defaultFeedbackSourceIdentifierSubtypeId = 8;
    private conversationId$ = new BehaviorSubject<string>('');
    private evaState$ = new BehaviorSubject<EvaState>({ show: false, prompt: '', suggestions: [] });
    private sessionId: string;
    private apiUrl = ''; // OpenAI API URL
    private apiKey = ''; // Replace with your OpenAI API key
    private configEnv: any;
    private cachedUserSettings: any = null;
    private cachedUserSettingsKey: string = '';
    public selectedContextPointId: number | null = null;
    public nextPromtDetails: EvaRequestPayload | null = null;
    public nextPromptDetailsV2: EvaV2RequestPayload | null = null;
    public nextV2ContextPointIds: EvaV2ContextPointId[] = [];
    public coolantHealthIqEvaContext: CoolantHealthIqEvaContext | null = null;
    public readonly botFlowSubject = new Subject<BotFlowEvent>();
    public readonly botFlow$ = this.botFlowSubject.asObservable();




    constructor(
        private httpClient: HttpClient,
        private aiAgentServiceConfig: AIAgentServiceConfig
    ) {
        this.configEnv = this.aiAgentServiceConfig.getEnvironment();
        // this.configEnv.apiWaterServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_WATER_SERVER_URL);
        // this.configEnv.apiPlatformServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_SERVER_URL);
    }
    public getDefaultCorporateId(): number | undefined {
        const userSettings = this.getCurrentUserSettings();

        if (userSettings?.DefaultContextPointId) {
            return Number(userSettings.DefaultContextPointId);
        }

        if (userSettings?.Accounts?.[0]?.AccountId) {
            return Number(userSettings.Accounts[0].AccountId);
        }

        // New user settings API doesn't have AccountId; fall back to Accounts[0].ContextPointId as the default context point.
        const accountContextPointId = Number(userSettings?.Accounts?.[0]?.ContextPointId);
        if (Number.isFinite(accountContextPointId) && accountContextPointId > 0) {
            return accountContextPointId;
        }

        return undefined;
    }
    public getCurrentUserSettings() {
        if (typeof window === 'undefined') {
            return {};
        }
        
const value =
        sessionStorage.getItem('ecolab.envision_UserSettings') ??
        sessionStorage.getItem('UserSettings');


        if (value === this.cachedUserSettingsKey && this.cachedUserSettings) {
            return this.cachedUserSettings;
        }

        if (!value) {
            return {};
        }

        try {
            this.cachedUserSettings = JSON.parse(value);
            this.cachedUserSettingsKey = value;
            return this.cachedUserSettings;
        } catch {
            return {};
        }
    }

    public emitBotFlow(event: BotFlowEvent): void {
        this.botFlowSubject.next(event);
    }

    public getEVAResponse(payload: EvaRequestPayload): Observable<EvaResponse | null> {
        const url = environment.evaConversationalServiceUrl + this.configEnv.apiUrl.getEvaResponse;
        return this.httpClient.post<EvaResponse>(url, payload).pipe(
            map(response => response),
            catchError(error => {
                console.error('Error calling EVA API:', error);
                return of(null);
            })
        );
    }

    public getEVAResponseV2(payload: EvaV2RequestPayload): Observable<EvaV2Response | null> {
        const url = environment.evaConversationalServiceUrl + this.configEnv.apiUrl.getEvaResponseV2;
        return this.httpClient.post<EvaV2Response>(url, payload).pipe(
            map(response => response),
            catchError(error => {
                return of(null);
            })
        );
    }

    public getLatestFeedback(queryParams: EvaFeedbackQueryParams): Observable<EvaFeedbackRecord | null> {
        if (!this.isFeedbackQueryValid(queryParams)) {
            return of(null);
        }

        const url = environment.evaConversationalServiceUrl + this.configEnv.apiUrl.getFeedback;
        const params = new HttpParams()
            .set('sourceIdentifier', String(queryParams.sourceIdentifier))
            .set('userId', String(queryParams.userId))
            .set('contextPointId', String(queryParams.contextPointId))
            .set('sourceIdentifierTypeId', String(queryParams.sourceIdentifierTypeId ?? this.defaultFeedbackSourceIdentifierTypeId))
            .set('sourceIdentifierSubtypeId', String(queryParams.sourceIdentifierSubtypeId ?? this.defaultFeedbackSourceIdentifierSubtypeId));

        return this.httpClient.get<EvaFeedbackRecord[]>(url, { params }).pipe(
            map((response) => this.getLatestFeedbackRecord(response)),
            catchError((error) => {
                console.error('Error calling feedback API:', error);
                return of(null);
            })
        );
    }

    public saveFeedback(payload: EvaFeedbackSaveRequest): Observable<boolean> {
        const url = environment.evaConversationalServiceUrl + this.configEnv.apiUrl.saveFeedback;

        return this.httpClient.post<boolean>(url, payload).pipe(
            map((response) => response === true),
            catchError((error) => {
                console.error('Error saving feedback:', error);
                return of(false);
            })
        );
    }

    public buildFeedbackSaveRequest(context: EvaFeedbackContext, thumbfeedback: 0 | 1, chatId?: string): EvaFeedbackSaveRequest | null {
        const identity = this.getCurrentUserFeedbackIdentity();

        if (!identity.userId || !context?.sourceIdentifier || !context?.contextPointId) {
            return null;
        }

        return {
            chatid: chatId || this.generateFeedbackChatId(),
            userid: identity.userId,
            sourceapplicationtypeid: context.sourceApplicationTypeId ?? this.defaultFeedbackSourceApplicationTypeId,
            sourceidentifier: context.sourceIdentifier,
            sourceidentifiertypeid: context.sourceIdentifierTypeId ?? this.defaultFeedbackSourceIdentifierTypeId,
            sourceidentifiersubtypeid: context.sourceIdentifierSubtypeId ?? this.defaultFeedbackSourceIdentifierSubtypeId,
            thumbfeedback,
            comments: null,
            answer: null,
            question: null,
            questionid: null,
            additionalsourcecontext: null,
            useremail: identity.userEmail,
            contextpointid: context.contextPointId
        };
    }

    public getCurrentUserFeedbackIdentity(): { userId: number | null; userEmail: string } {
        const userInfo = this.getCurrentUserInfo();
        const rawUserId = userInfo?.UserId ?? userInfo?.userId ?? userInfo?.ID ?? userInfo?.id;
        const parsedUserId = Number(rawUserId);
        const userEmail = userInfo?.EmailAddress
            ?? userInfo?.emailAddress
            ?? userInfo?.Email
            ?? userInfo?.email
            ?? userInfo?.preferred_username
            ?? userInfo?.UserName
            ?? '';

        return {
            userId: Number.isFinite(parsedUserId) && parsedUserId > 0 ? parsedUserId : null,
            userEmail: String(userEmail ?? '')
        };
    }

    public generateFeedbackChatId(): string {
        const generatedUuid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID()
            : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
                const random = Math.floor(Math.random() * 16);
                const value = char === 'x' ? random : (random & 0x3) | 0x8;

                return value.toString(16);
            });

        return `i${generatedUuid.slice(1)}`;
    }

    /**
     * Get the EVA state observable to subscribe to EVA visibility and prompt changes
     */
    public getEvaState$(): Observable<EvaState> {
        return this.evaState$.asObservable();
    }

    /**
     * Update the EVA state to show/hide EVA and set the prompt
     */
    public setEvaState(state: EvaState): void {
        this.evaState$.next(state);
    }

    /**
     * DCI (Legionella Dashboard, Coolant Health IQ) specific flow.
     * This is a temporary solution and these methods will be removed after the API is unified.
     */
    public getLegionellaSpecificEvaResponse(payload: EvaDciRequestPayload, queryParams: EvaDciQueryParams): Observable<EvaDciResponse | null> {
        const url = environment.apiWsiServerUrl + this.configEnv.apiUrl.getEvaChatResponse;
        let params = new HttpParams()
            .set('startDate', queryParams.startDate)
            .set('endDate', queryParams.endDate)
            .set('corporateCpId', queryParams.corporateCpId.toString());

        for (const siteId of queryParams.siteIds || []) {
            params = params.append('siteIds', siteId.toString());
        }

        return this.httpClient.post<EvaDciResponse>(url, payload, { params }).pipe(
            catchError(error => {
                console.error('Error calling EVA API:', error);
                return throwError(() => error);
            })
        );
    }

    public getLegionellaChatHistory(): Observable<EvaDciChatHistory[] | null> {
        const url = environment.apiWsiServerUrl + this.configEnv.apiUrl.getEvaChatSessions;

        return this.httpClient.get<EvaDciChatHistory[]>(url).pipe(
            catchError(error => {
                console.error('Error calling EVA API:', error);
                return throwError(() => error);
            })
        );
    }

    public getLegionellaConversationBySessionId(sessionId: string): Observable<EvaDciConversation | null> {
        const url = `${environment.apiWsiServerUrl}${this.configEnv.apiUrl.getEvaChatSessions}/${encodeURIComponent(sessionId)}`

        return this.httpClient.get<EvaDciConversation>(url).pipe(
            catchError(error => {
                console.error('Error calling EVA API:', error);
                return throwError(() => error);
            })
        );
    }

    public getCoolantHealthIqEvaResponse(payload: CoolantHealthIqEvaPayload): Observable<EvaV2Response | null> {
        const url = environment.datacenterAggrServiceUrl + this.configEnv.apiUrl.getEvaChatResponse2;
        return this.httpClient.post<EvaV2Response>(url, payload).pipe(
            catchError(error => {
                console.error('Error calling Coolant Health IQ EVA API:', error);
                return throwError(() => error);
            })
        );
    }

    public getCoolantHealthIqChatHistory(): Observable<EvaCoolantChatHistory[] | null> {
        const url = environment.datacenterAggrServiceUrl + this.configEnv.apiUrl.getEvaChatSessions2;

        return this.httpClient.get<EvaCoolantChatHistory[]>(url).pipe(
            catchError(error => {
                console.error('Error calling Coolant Health IQ chat history API:', error);
                return throwError(() => error);
            })
        );
    }

    public getCoolantHealthIqConversationBySessionId(sessionId: string): Observable<EvaCoolantConversation | null> {
        const url = `${environment.datacenterAggrServiceUrl}${this.configEnv.apiUrl.getEvaChatSessions2}/${encodeURIComponent(sessionId)}`;

        return this.httpClient.get<EvaCoolantConversation>(url).pipe(
            catchError(error => {
                console.error('Error calling Coolant Health IQ conversation API:', error);
                return throwError(() => error);
            })
        );
    }

    // End DCI (Legionella Dashboard, Coolant Health IQ) specific flow.

    private isFeedbackQueryValid(queryParams: EvaFeedbackQueryParams | null | undefined): boolean {
        return !!queryParams
            && Number.isFinite(queryParams.userId)
            && queryParams.userId > 0
            && Number.isFinite(queryParams.contextPointId)
            && queryParams.contextPointId > 0
            && `${queryParams.sourceIdentifier ?? ''}`.trim().length > 0;
    }

    private getLatestFeedbackRecord(records: EvaFeedbackRecord[] | null | undefined): EvaFeedbackRecord | null {
        if (!Array.isArray(records) || !records.length) {
            return null;
        }

        return records.reduce<EvaFeedbackRecord>((latestRecord, currentRecord) => {
            const latestTimestamp = new Date(latestRecord.modifiedon ?? latestRecord.createdon ?? 0).getTime();
            const currentTimestamp = new Date(currentRecord.modifiedon ?? currentRecord.createdon ?? 0).getTime();

            if (currentTimestamp > latestTimestamp) {
                return currentRecord;
            }

            if (currentTimestamp === latestTimestamp && (currentRecord.id ?? 0) > (latestRecord.id ?? 0)) {
                return currentRecord;
            }

            return currentRecord === records[records.length - 1] && !Number.isFinite(currentTimestamp) ? currentRecord : latestRecord;
        }, records[0]);
    }

    private getCurrentUserInfo(): any {
        try {
            const raw = sessionStorage.getItem('ecolab.envision_msalUserInfo');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }

}